
import { defineComponent } from "vue-demi";

export default defineComponent({
  name: "FileView",

  components: {
    ActionItems: () => import("@/modules/Documents/components/ActionItems.vue"),
    ActionItem: () => import("@/modules/Documents/components/ActionItem.vue"),
  },

  props: {
    name: {
      type: String,
      default: "File",
    },
    size: {
      type: Number,
      default: 0,
    },
    date: {
      type: String,
      default: "",
    },
    error: {
      type: String,
      default: "",
    },
    errorTooltip: {
      type: String,
      default: "This file format isn't recognised. Please upload only PDF files.",
    },
    canDelete: {
      type: Boolean,
      default: false,
    },
    actionDelete: {
      type: Boolean,
      default: false,
    },
    actionView: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    preview: {
      type: String,
      default: "",
    },
  },

  emits: ["delete", "view", "download", "reupload"],

  setup(props, { emit }) {
    function formatBytes(bytes: number, decimals = 0) {
      if (!bytes) return "0 b";

      const k = 1024,
        sizes = ["b", "kb", "mb", "gb", "tb"];

      const i = Math.floor(Math.log(bytes) / Math.log(k));

      return `${(bytes / Math.pow(k, i)).toFixed(decimals)} ${sizes[i]}`;
    }

    function formatDate(isoString: string) {
      if (!isoString) return "";

      const date = new Date(isoString);

      const formattedDate = date.toLocaleDateString("en-GB"); // dd/MM/yyyy

      if (!formattedDate) return "";

      return `Uploaded on ${formattedDate}`;
    }

    const onDelete = () => {
      emit("delete");
    };

    const onView = () => {
      emit("view");
    };

    const onDownload = () => {
      emit("download");
    };

    const onReuploadFile = () => {
      emit("reupload");
    };

    return {
      formatBytes,
      formatDate,
      onDelete,
      onView,
      onDownload,
      onReuploadFile,
    };
  },
});
